export default __webpack_public_path__ + "static/media/logo3.34825f6f.svg";